let _timer;

export default function debounce(func, ms) {
  clearTimeout(_timer);
  _timer = setTimeout(() => {
    func();
  }, ms);
}
